import React, {forwardRef} from 'react';
import {ScrollView, ScrollViewProps} from 'react-native';

// Simple wrapper so any ref and props go straight to RNW's ScrollView
const KeyboardAwareScrollView = forwardRef<any, ScrollViewProps>(
  (props, ref) => <ScrollView {...props} ref={ref} />,
);

KeyboardAwareScrollView.displayName = 'KeyboardAwareScrollView';

export default KeyboardAwareScrollView;
export {KeyboardAwareScrollView};
